module.exports = __webpack_public_path__ + "img/sw10.28dc7ebf.jpg";